import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-text text-dark">
        Developed and desined by Ashutosh Maurya
      </p>
      <hr />
      <p className="footer-text text-dark">
        &#169; 2022 copywrites ashutosh-maurya.netlify.app | All right reserved.
      </p>
    </div>
  );
};

export default Footer;
